var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThought(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 708,
    height: 473,
    viewBox: "0 0 708 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M594.915 468.828C589.627 473.429 581.798 473.42 576.34 468.991L560.874 456.439L560.873 456.437L550.269 447.771C543.007 441.835 543.015 430.716 549.952 424.343C575.427 400.936 595.981 374.184 610.721 345.168C628.111 310.936 637.065 274.23 637.065 237.155C637.065 200.08 628.111 163.374 610.721 129.142C595.981 100.127 575.427 73.3737 549.952 49.9671C543.015 43.5939 543.007 32.4756 550.269 26.5392L560.874 17.8713L576.335 5.23433C581.792 0.773617 589.646 0.750721 594.949 5.3655C629.09 35.0786 656.408 69.6061 675.555 107.298C696.455 148.439 707.212 192.543 707.212 237.082C707.212 281.621 696.455 325.725 675.555 366.867C656.401 404.57 629.072 439.108 594.915 468.828Z",
    stroke: "#D6D9DE",
    strokeWidth: 0.956965
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M563.805 146.363C499.101 23.9664 391.027 1.6942 314.415 1.22461C261.888 1.22461 3.64163 28.9307 3.64163 212.71C3.64163 290.528 38.5931 308.574 20.849 362.578C14.789 381.071 8.67305 401.845 2.50118 424.899C-3.40234 448.882 1.29364 465.151 15.0126 466.929C29.5702 468.74 50.2325 462.937 72.0353 454.652C89.8465 447.775 110.106 437.344 129.058 428.757C191.179 467.464 270.239 479.071 366.071 454.35C487.328 420.505 641.256 299.518 563.805 146.363Z",
    fill: "#3162AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M484.029 31.8982L505.061 29.7087M467.445 26.9834L492.204 10.2002M462.467 16.5377L466.607 -4.66163",
    stroke: "#3162AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThought);
export default __webpack_public_path__ + "static/media/Thought.3200d05a9a8593bdaa7efd971ce1081b.svg";
export { ForwardRef as ReactComponent };